import React from 'react';
import Moment from "moment";

export default function ArchiveItem({ apartment }) {
	return (
		<div className="col-12 col-md-6 col-lg-4">
			<article className="tease tease-is-col" data-equalizer-watch="">
				<div className="tease-img">
					<a href={"/wohnungen/wohnung?id=" + apartment.apartmentId} className="img-hover-link" aria-label={apartment.title}>
						<img className="tease-img-inner img-fluid" src={apartment.meta.thumbnailId.node.mediaItemUrl}
							 alt=""/>
					</a>
				</div>
				<div className="tease-wrapper">
					<a href={"/wohnungen/wohnung?id=" + apartment.apartmentId}>
						<h3 className="tease-title">{apartment.title}</h3>
						<p>{apartment.meta.numberOfRooms} Zimmerwohnung</p>
						<p>{apartment.meta.rentPerMonth}.-/Mt. inkl. Nebenkosten</p>
						<p>Verfügbar {apartment.meta.availableByAgreement ? 'nach Vereinbarung' : 'ab ' + Moment(apartment.meta.availabilityDate).format('DD.MM.YYYY')}</p>
						<i className="icon-long-arrow-right"></i>
					</a>
				</div>
			</article>
		</div>
	);
}
